function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m18.5 8h-15c-1.933 0-3.5-1.567-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5h15c1.933 0 3.5 1.567 3.5 3.5 0 1.933-1.567 3.5-3.5 3.5z",
  fill: "#cfd8dc"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m18.5 15h-15c-1.933 0-3.5-1.567-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5h15c1.933 0 3.5 1.567 3.5 3.5 0 1.933-1.567 3.5-3.5 3.5z",
  fill: "#90a4ae"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m18.5 22h-15c-1.933 0-3.5-1.567-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5h15c1.933 0 3.5 1.567 3.5 3.5 0 1.933-1.567 3.5-3.5 3.5z",
  fill: "#cfd8dc"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11 1h-7.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5h7.5z",
  fill: "#b4bcc0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11 8h-7.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5h7.5z",
  fill: "#7d8f97"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11 15h-7.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5h7.5z",
  fill: "#b4bcc0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fafafa"
}, React.createElement("circle", {
  cx: 3.5,
  cy: 4.5,
  r: 1
}), React.createElement("circle", {
  cx: 8.5,
  cy: 4.5,
  r: 1
}), React.createElement("circle", {
  cx: 3.5,
  cy: 11.5,
  r: 1
}), React.createElement("circle", {
  cx: 8.5,
  cy: 11.5,
  r: 1
}), React.createElement("circle", {
  cx: 3.5,
  cy: 18.5,
  r: 1
}), React.createElement("circle", {
  cx: 8.5,
  cy: 18.5,
  r: 1
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m4.5 4.5h-2c0 .553.448 1 1 1s1-.447 1-1z",
  fill: "#dadada"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m9.5 4.5h-2c0 .553.448 1 1 1s1-.447 1-1z",
  fill: "#dadada"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m4.5 11.5h-2c0 .553.448 1 1 1s1-.447 1-1z",
  fill: "#dadada"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m9.5 11.5h-2c0 .553.448 1 1 1s1-.447 1-1z",
  fill: "#dadada"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m4.5 18.5h-2c0 .553.448 1 1 1s1-.447 1-1z",
  fill: "#dadada"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m9.5 18.5h-2c0 .553.448 1 1 1s1-.447 1-1z",
  fill: "#dadada"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m23.744 21.406-5.28-8.579c-.301-.511-.861-.827-1.464-.827s-1.163.316-1.456.814l-5.271 8.565c-.179.266-.273.582-.273.916 0 .94.768 1.705 1.712 1.705h10.576c.944 0 1.712-.765 1.712-1.705 0-.334-.094-.65-.256-.889z",
  fill: "#607d8b"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17 22.5c-.553 0-1-.447-1-1s.447-1 1-1 1 .447 1 1-.447 1-1 1z",
  fill: "#fff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m18 18.5c0 .553-.447 1-1 1s-1-.447-1-1v-3c0-.553.447-1 1-1s1 .447 1 1z",
  fill: "#fff"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17 12c-.603 0-1.163.316-1.456.814l-5.271 8.565c-.179.266-.273.582-.273.916 0 .94.768 1.705 1.712 1.705h5.288v-1.5c-.553 0-1-.447-1-1s.447-1 1-1v-1c-.553 0-1-.447-1-1v-3c0-.553.447-1 1-1z",
  fill: "#546d79"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17 20.5c-.553 0-1 .447-1 1s.447 1 1 1z",
  fill: "#dedede"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17 14.5c-.553 0-1 .447-1 1v3c0 .553.447 1 1 1z",
  fill: "#dedede"
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.6a5d0727.svg";
export { ForwardRef as ReactComponent };